import { post, } from "./index";

// FAQ Types
export const getPaymentLink = (data) => {
  const request = {
    subUrl: `/getPaymentLink`,
    data,
  };
  return post(request);
};